!function(window) {
function toggleRows(options){
	
	// need to delegate click because content will be added and removed
	// all the time
	$('.iopr-data-wrapper').on('click', 'tr.has-children', function (ev) {
		ev.stopPropagation();

		var $target = $(ev.target);
		if (!$target.hasClass('chart-manipulation-toggle')) {
			var $tr = $(this);
			var $parentTable = $tr.closest('.main-table-wrapper');
			if (!$parentTable.hasClass('animation-in-progress')) {
				if ($tr.hasClass('children-shown')) {
					// hide all children
					hideChildren($tr);
				} else {
					// show children
					showChildren($tr);
				}
			}

		}

	});

	function showChildren($tr) {
		var id = $tr.attr('data-id');
		var $childrenWrapper = $tr.next('.tr-children-wrapper');
		if ($childrenWrapper.length) {
			var $elements = $childrenWrapper.find('.value-row[data-parent-id="' + id + '"]');
			$elements.each(function (i, item) {
				var $trChild = $(item);
				$trChild.slideRow('down', '500', function () {
					if (!$tr.hasClass('children-shown')) {
						$tr.addClass('children-shown');
					}
				});
			});
		}
	}

	// hide children recursively because we want to make it special
	function hideChildren($tr, $hide = false) {
		var id = $tr.attr('data-id');
		if ($tr.hasClass('has-children')) {
			var $childrenWrapper = $tr.next('.tr-children-wrapper');
			var $elements = $childrenWrapper.find('.value-row[data-parent-id="' + id + '"]');
			$elements.each(function (i, item) {
				var $trChild = $(item);
				hideChildren($trChild, true);
			});
		}
		if ($hide) {
			$tr.slideRow('up', '500', function () {
				$tr.removeClass('children-shown');
			});
		} else {
			$tr.removeClass('children-shown');
		}

	}
}

module.exports = toggleRows;
window.toggleRows = toggleRows;
}.call(window, window);